module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-dark-screens-1.09ee2526.png";